import React from 'react'
import SEO from '../../../utils/CommonFunctionality/SEO'
import Layout from '../Layout'

export default function howItWorks(props) {
    return (
        <Layout props={props}>
            <SEO title={`${global?.storeDetails?.name} | How it works`} />

            <div className="px-md-5 px-3 py-4 staticPgWrapper">
                {/* <h2>FAQs</h2> */}
                <span
                    dangerouslySetInnerHTML={{
                        __html: global.storeDetails.how_it_work,
                    }}
                ></span>
            </div>
        </Layout>
    )
}
